import styled from 'styled-components';

import { getCurrentCountry } from '@front/common/src/utils/country';
import { formatPercentage, formatPricePerMonth } from '@front/common/src/utils/formatting';

import { MEMBERSHIP_CONFIG_BY_COUNTRY } from '@front/customer/src/constants/country-config';

import { translate } from '@front/i18n';

import Title from '@front/web-ui/src/components/base-text/variants/title';
import { minWidth } from '@front/web-ui/src/styles/mixins';

import Advantages from '../advantages';
import { MembershipBackground } from '../common';

const t = translate('modals.membership_paywall');

const StyledTitle = styled(Title.LG)`
  margin: 20px 0;

  ${minWidth.md`
    margin: 0 0 20px;
  `}
`;

const WellnessHeader = () => {
  const currentCountry = getCurrentCountry();

  const membershipConfig = MEMBERSHIP_CONFIG_BY_COUNTRY[currentCountry];
  const formattedWellnessMemberReductionPercentage = formatPercentage(membershipConfig.wellnessReductionsPercentage);
  const formattedMembershipPricePerMonth = formatPricePerMonth(membershipConfig.monthlyPrice);

  const advantages = [
    t('.advantages.wellness.prestation_reductions', {
      reductionsInPercentage: formattedWellnessMemberReductionPercentage,
    }),
    t('.advantages.wellness.free_month', { pricePerMonth: formattedMembershipPricePerMonth }),
    t('.advantages.wellness.cancel_anytime'),
  ];

  return (
    <MembershipBackground>
      <StyledTitle>{t('.title.wellness')}</StyledTitle>
      <Advantages advantages={advantages} />
    </MembershipBackground>
  );
};

export default WellnessHeader;
